import React, { useEffect, useState } from "react";
import EPromotionsBanner from "./view/_promotions-banner";
import { useSelector } from "react-redux";
import { promotionsService } from "./service/promotions_service";
import moment from "moment";
import { commonService } from "../../../services/common.service";
import { makeStyles } from "@material-ui/core/styles";
import { Card, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { Skeleton } from "@material-ui/lab";

const useStyles = makeStyles((theme) => ({
  card: {
    width: "100%",
    height: "100%",
  },
  content: {
    marginTop:'1rem',
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  image: {
    height: "47%",
    marginBottom: "5px",
  },
  heading: {
    textTransform: "Uppercase",
    color: theme.palette.ePrimary?.base,
    marginBottom: "5px",
  },
  emptyStyle:{
    fontStyle: 'italic'
  }
}));

export default function E_Promotions() {
  const styles = useStyles();
  const [data, setData] = useState([]);
  const [NoTipsImage, setNoTipsImage] = useState("");
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const {t:content, ready: contentReady} = useTranslation("content-E_PROMOTIONS")
  const {t:labels, ready: labelReady} = useTranslation("label-E_PROMOTIONS");
  const noTipsimage = useSelector(
    (store) => store?.parametersWidgets?.ParameterLookup?.E_NO_TIPS_IMAGE
  );
  const customerClass = useSelector(
    (store) => store?.meterDetails?.customerClassCd
  );
  const backendDataFormat = useSelector(
    (state) => state?.parametersWidgets?.ParameterLookup?.YEAR_DATE_FORMAT
  );

  const languageCode = useSelector(
    (state) =>
      state?.parametersWidgets?.ParameterLookup?.TENANT_PRIMARY_LANGUAGE
  );

  useEffect(() => {
    if (noTipsimage) {
      commonService.getAssestUrl(noTipsimage)
      .then((response) => {
        setNoTipsImage(response);
      })
      .catch((error)=>{
        setNoTipsImage("");
      });
    }
  }, [noTipsimage]);

  useEffect(() => {
    if (backendDataFormat) {
      setStartDate(
        moment()
          .subtract(1, "year")
          .format(backendDataFormat)
      );
      setEndDate(
        moment()
        .add(1, "day")
        .format(backendDataFormat)
      );
    }
  }, [backendDataFormat]);
 

  useEffect(() => {
    if (customerClass && languageCode && startDate && endDate) {
      promotionsService
        .getPromotions(startDate, customerClass, endDate)
        .then((res) => {
          let filterPromotions=res?.data?.getAnnouncementList.filter((e)=>e?.AnnouncementType=="PROMOTIONS")
          if(filterPromotions){
            setData(filterPromotions);
          }else{
            setData([]);
          }
        })
        .catch((error) => {
          setData([]);
        });
    }
  }, [customerClass,languageCode, startDate, endDate]);

  return (
    <>
      {data.length ? (
        <EPromotionsBanner data={data} />
      ) : (
        <Card className={styles.card}>
        {/* {
          labelReady ?
          <Typography variant="h6" className={styles.heading}>
          {labels("E_PROMOTIONS_HEADING")}
          </Typography>
          : <Skeleton />
        } */}
          <div className={styles.content}>
            {NoTipsImage && (
              <img
                className={styles.image}
                src={NoTipsImage?.assetPath}                
              />
            )}
            {
            labelReady ?
            <Typography  className={styles.emptyStyle} variant="body2">Placeholder for promotions</Typography>
            : <Skeleton />
            }
          </div>
        </Card>
      )}
    </>
  );
}
